export default __webpack_public_path__ + "static/media/question-inside-chat.cab326c6.svg";